module.exports = __webpack_public_path__ + "assets/img/kv-b0a15934.jpg";